import useRequest from '@/websdk/utils/request';
import { useEffect, useState } from 'react';
import { transformTempData } from '@/utils/common';
export default (function (param) {
  const [temperature, setTemperature] = useState({});
  const { data, exec, isRequestSuccessed } = useRequest({
    url: '',
    name: 'GET_PRODUCE_PROCESS_ANALYSIS_TEMPERATURE',
    method: 'GET',
  });

  useEffect(() => {
    if (param && param.params && JSON.stringify(param.params) !== '{}') {
      let url = `/api/produce/process/analysis/temperature`;
      Object.keys(param.params).forEach((key, index) => {
        if (index === 0) {
          url += `?${key}=${param.params[key]}`;
        } else {
          url += `&${key}=${param.params[key]}`;
        }
      });
      exec(url);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [param]);

  useEffect(() => {
    if (data && JSON.stringify(data) !== '{}') {
      let new_data = transformTempData(data, param.pageIndex, param.pageSize);
      setTemperature(new_data);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  return [temperature, isRequestSuccessed];
});
